export default "__VITE_ASSET__D2BV2KCP__"